// Web stub — react-native-iap δεν υποστηρίζεται στο web.

export const IAP_PRODUCTS = [
  { id: 'credits_5',  credits: 5,  label: '5 μελάνια' },
  { id: 'credits_10', credits: 10, label: '10 μελάνια' },
  { id: 'credits_20', credits: 20, label: '20 μελάνια' },
] as const;

export type IAPProductId = (typeof IAP_PRODUCTS)[number]['id'];
export type IAPProduct = { id: string; displayPrice: string; type: string };

export async function fetchIAPProducts(): Promise<IAPProduct[]> {
  return [];
}

export function purchaseProduct(_productId: string): Promise<never> {
  return Promise.reject(new Error('WEB_NOT_SUPPORTED'));
}

export async function verifyAndCredit(_purchase: unknown): Promise<number> {
  throw new Error('WEB_NOT_SUPPORTED');
}
